module.exports = __webpack_public_path__ + "static/Untitled-1-08-9719f2fe4dfe005904a6486c7335dd86.jpg";